import Card from '@/components/atoms/Card';
import LinkButton from '@/components/atoms/LinkButton';
import { Text } from '@/components/atoms/Text';

import { CarouselBlockCardStrapiProps } from '../../organisms/CarouselBlock/CarouselBlockStrapi';

import iconChevronRightSrc from '~/svg/IconChevronRight.svg';
import { SvgIcon } from '@/components/SvgIcon';

export const CarouselItem = (item: CarouselBlockCardStrapiProps) => {
  const { cardUrl, cardTitle, actionLabel, renderImage } = item;

  const Content = () => (
    <Card
      classNames={{
        root: 'h-[208px] w-[240px] shadow-md flex-col p-6 group bg-base-white dark:bg-gray-50 dark:border-gray-300 dark:focus:bg-border-brand-500 rounded-s',
      }}
      hasHoverEffect={!!cardUrl}
    >
      {renderImage({ classNames: { image: 'w-6 h-6' } })}
      {cardTitle && (
        <Text
          variant='subtitle-l'
          classNames={{ wrapper: 'mt-4 block font-serif text-base-black' }}
        >
          {cardTitle}
        </Text>
      )}
      {actionLabel && (
        <Text
          color='brand-500'
          variant='body-l'
          classNames={{
            wrapper: 'absolute bottom-5 flex items-center gap-1',
          }}
        >
          {actionLabel}
          <span className='transition duration-75 ease-in-out group-hover:translate-x-2'>
            <SvgIcon src={iconChevronRightSrc} />
          </span>
        </Text>
      )}
    </Card>
  );

  if (cardUrl) {
    return (
      <LinkButton href={cardUrl} noStyles>
        <Content />
      </LinkButton>
    );
  } else {
    return <Content />;
  }
};
